<template>
  <div style="position: relative; overflow-x: clip;">
    <Section class="find-it">
      <div class="d-flex px-1" >
        <div class="mr-auto">
          <span class="black--text font-weight-bold">Received</span><br>
          {{ formatRelative(currentLead.lead_date) }} &nbsp;({{ formatDate(currentLead.lead_date )}})
        </div>
        <StatusSelect v-if="!isRefunded" :value="currentLead.status" @input="updateStatus"/>
      </div>

      <v-divider class="my-3"/>
      
      <div class="px-1">
        <span class="black--text font-weight-bold">Job Details</span><br>
        {{ currentLead.friendly_structure_type ? currentLead.friendly_structure_type + ' - ' : '' }}{{ currentLead.service }}<br>
        <span v-if="currentLead.notes && !isRefunded">{{ currentLead.notes }}<br></span>
      </div>

      <v-divider class="my-3"/>
      
      <div class="px-1" v-if="!isRefunded">
        <span class="black--text font-weight-bold">Contact</span><br>
        {{ currentLead.customer.name }}<br>
        <a :href="`tel:${ currentLead.customer.phone }`">{{ currentLead.customer.phone}}</a><br>
        Zipcode: {{ currentLead.customer.zipcode }}
      </div>

      <div class="px-1" v-else>
        <span class="black--text font-weight-bold">Contact</span><br>
        Removed due to refund...<br>
        Zipcode: {{ currentLead.customer.zipcode }}
      </div>

      <v-divider class="my-3"/>
      
      <div class="px-1">
        <span class="black--text font-weight-bold">From</span><br>
        {{ currentLead.user.display_name }} @ {{ currentLead.account.account_name }}<br>
        Lead Cost: <span v-if="currentLead.price_cents > 0">{{ formatCurrency(currentLead.price_cents) }} <em>(plus tax)</em></span>
        <span v-else>Free!</span>
      </div>
    </Section>

    <div v-if="isDisputed" class="overlay">Pending Review</div>
    <div v-else-if="isRefunded" class="overlay">Refunded</div>
  </div>
</template>

<script>
import { Section } from '@/components/pages'
import { StatusSelect } from '@/components/inputs'
import { mapActions, mapGetters } from 'vuex'
import formatters from '@/lib/formatters'

export default {
  name: 'LeadBaseSection',

  components: { Section, StatusSelect },

  computed: {
    ...mapGetters('leads', ['currentLead']),

    isDisputed() {
      return this.currentLead.system_status == 'disputed'
    },

    isRefunded() {
      return this.currentLead.system_status == 'refunded'
    },
  },

  methods: {
    ...mapActions('leads', ['updateCurrent']),

    ...formatters,

    updateStatus(newStatus) {
      const lead = { lead_id: this.currentLead.lead_id, status: newStatus }

      this.updateCurrent(lead)
    },
  },
}
</script>

<style scoped>
  .overlay {
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 48px;
    font-weight: bold;
    color: rgba(0,0,0,0.3);
    transform: rotate(-45deg);
    text-align: center;
  }
</style>